module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-5 mb-10"
  }, [_c('section', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-card', {
    staticClass: "mb-4",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "d-flex align-center gap-15 pa-3"
  }, [_c('div', [_c('v-img', {
    attrs: {
      "src": require('@/assets/apps/total_consultant.svg'),
      "height": "45",
      "width": "45"
    }
  })], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "grey--text font-size-12"
  }, [_vm._v("\n                                Total Konsultan\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "font-weight-bold black--text mt-1 font-size-24"
  }, [_vm._v("\n                                " + _vm._s(_vm.formatNumber(_vm.data.total)) + "\n                                "), _c('span', {
    staticClass: "font-size-12 font-weight-500"
  }, [_vm._v("\n                                    Konsultan\n                                ")])])])])], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "d-flex align-center gap-10 pa-3"
  }, [_c('div', [_c('v-img', {
    attrs: {
      "src": require('@/assets/apps/total_consultant_active.svg'),
      "height": "45",
      "width": "45"
    }
  })], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "grey--text font-size-12"
  }, [_vm._v("\n                                Total Konsultan Aktif\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "font-weight-bold black--text mt-1 font-size-24"
  }, [_vm._v("\n                                " + _vm._s(_vm.formatNumber(_vm.data.active)) + "\n                                "), _c('span', {
    staticClass: "font-size-12 font-weight-500"
  }, [_vm._v("\n                                    Konsultan\n                                ")])])])])], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "d-flex align-center gap-10 pa-3"
  }, [_c('div', [_c('v-img', {
    attrs: {
      "src": require('@/assets/apps/total_consultant_nonactive.svg'),
      "height": "45",
      "width": "45"
    }
  })], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "grey--text font-size-12"
  }, [_vm._v("\n                                Total Konsultan Nonaktif\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "font-weight-bold black--text mt-1 font-size-24"
  }, [_vm._v("\n                                " + _vm._s(_vm.formatNumber(_vm.data.non_active)) + "\n                                "), _c('span', {
    staticClass: "font-size-12 font-weight-500"
  }, [_vm._v("\n                                    Konsultan\n                                ")])])])])], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "d-flex align-center gap-10 pa-3"
  }, [_c('div', [_c('v-img', {
    attrs: {
      "src": require('@/assets/apps/total_consultant_online.svg'),
      "height": "45",
      "width": "45"
    }
  })], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "grey--text font-size-12"
  }, [_vm._v("\n                                Total Konsultan Online\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "font-weight-bold black--text mt-1 font-size-24"
  }, [_vm._v("\n                                " + _vm._s(_vm.formatNumber(_vm.data.online)) + "\n                                "), _c('span', {
    staticClass: "font-size-12 font-weight-500"
  }, [_vm._v("\n                                    Konsultan\n                                ")])])])])], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "d-flex align-center gap-10 pa-3"
  }, [_c('div', [_c('v-img', {
    attrs: {
      "src": require('@/assets/apps/total_consultant_busy.svg'),
      "height": "45",
      "width": "45"
    }
  })], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "grey--text font-size-12"
  }, [_vm._v("\n                                Total Konsultan Sibuk\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "font-weight-bold black--text mt-1 font-size-24"
  }, [_vm._v("\n                                " + _vm._s(_vm.formatNumber(_vm.data.busy)) + "\n                                "), _c('span', {
    staticClass: "font-size-12 font-weight-500"
  }, [_vm._v("\n                                    Konsultan\n                                ")])])])])], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "d-flex align-center gap-10 pa-3"
  }, [_c('div', [_c('v-img', {
    attrs: {
      "src": require('@/assets/apps/total_consultant_offline.svg'),
      "height": "45",
      "width": "45"
    }
  })], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "grey--text font-size-12"
  }, [_vm._v("\n                                Total Konsultan Offline\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "font-weight-bold black--text mt-1 font-size-24"
  }, [_vm._v("\n                                " + _vm._s(_vm.formatNumber(_vm.data.offline)) + "\n                                "), _c('span', {
    staticClass: "font-size-12 font-weight-500"
  }, [_vm._v("\n                                    Konsultan\n                                ")])])])])], 1)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c9159db4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/Konsul/components/ConsultantManagementStatistic.vue
// module id = 1587
// module chunks = 1